// App.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import AdSenseBlock from './components/AdSenseBlock';
import { Link, NavLink } from "react-router-dom";
import { AD_SLOTS } from './constants/adSlots'; 

export default function App({ children }) {
  const location = useLocation();
  const path = location.pathname;

//  let adSlot = null;

//  if (path.startsWith("/blog")) {
//    adSlot = AD_SLOTS.BLOG;
//  } else if (path === "/basics") {
//    adSlot = AD_SLOTS.BASICS;
//  }
  
  return (
    <div className="App">
      <header className="App-header">
        <h1>
          <Link to="/">
            TrailRun Simulator{' '}
            <span className="version-info">
              R{process.env.REACT_APP_VERSION}
            </span>
          </Link>
        </h1>
        <nav style={{ marginBottom: '1rem' }}>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/how-to-use">使い方</NavLink>
          <NavLink to="/basics">トレラン基礎知識</NavLink>
          <NavLink to="/blog">トレラン記録</NavLink>
          <NavLink to="/AffordableGear">トレランギア</NavLink>
          <NavLink to="/faq">FAQ</NavLink>
          <NavLink to="/privacy">プライバシー</NavLink>
          <NavLink to="/contact">お問い合わせ</NavLink>
        </nav>
      </header>

      {/* ✅ 広告表示ページだけにAdSenseを出す */}
      {/*adSlot && <AdSenseBlock adSlot={adSlot} />*/}
      <main>
        {children}
      </main>
    </div>
  );
}
